import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import FullscreenMedia from 'views/fullScreen/FullScreenMedia';
import SubtitleTest from 'views/test/SubtitleTest';

const Router: React.FC = () => (
  <BrowserRouter>
    <Switch>
      <Route
        path={['/', '/media/:id']}
        exact
        component={() => <FullscreenMedia />}
      />
      <Route path={['/test']} exact component={() => <SubtitleTest />} />
      <Route component={() => <div>404</div>} />
    </Switch>
  </BrowserRouter>
);
export default Router;
